export default "__VITE_ASSET__2319a280__"